import { Component, Input } from '@angular/core';
import { ProductCartStatus } from '@app/shared/models/requests';

interface IStatoBadge {
  class: string;
  icon: string;
  label: string;
}

@Component({
  selector: 'app-product-cart-state',
  templateUrl: './product-cart-state.component.html',
  styleUrl: './product-cart-state.component.scss'
})
export class ProductCartStateComponent {

  @Input() state: ProductCartStatus.ALL;

  styles: { [key in ProductCartStatus] : IStatoBadge } = {
    VALID: { class: 'chip chip-info', icon:'', label: ''  },
    UNDER_APPROVAL: { class: 'chip chip-warning', icon:'', label: ''  },
    APPROVED: { class: 'chip chip-success', icon:'', label: ''  },
    NOT_APPROVED: { class: 'chip chip-danger', icon:'', label: '' },
    DELETED: { class: 'chip chip-dark', icon:'', label: '' },
    ALL: { class: 'chip chip-default', icon:'', label: '' },
  }

}
